import Combine from '../../components/Combine/Combine'
import InstructorOwner from './InstructorOwner'

const Instructor = () => {
  return (
  <Combine>
    <InstructorOwner/>
  </Combine>
  )
}

export default Instructor
